var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "fixed width-100 z-99" },
        [
          _c(
            "van-tabs",
            {
              on: { change: _vm.tabsChange },
              model: {
                value: _vm.tabIndex,
                callback: function ($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex",
              },
            },
            [
              _c("van-tab", { attrs: { title: "我的待办" } }),
              _c("van-tab", { attrs: { title: "我的已办" } }),
              _c("van-tab", { attrs: { title: "我的发起" } }),
              _c("van-tab", { attrs: { title: "抄送我的" } }),
            ],
            1
          ),
          _c("van-search", {
            staticClass: "fixed width-100 z-99",
            attrs: { clearable: "", shape: "round", "show-action": "" },
            on: { search: _vm.onSearch },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-110 h-52 l-h-52 bg-FFDA3E b-r-28 text-center",
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.queryParams.startUserName,
              callback: function ($$v) {
                _vm.$set(_vm.queryParams, "startUserName", $$v)
              },
              expression: "queryParams.startUserName",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "h-210" }),
      _c(
        "van-pull-refresh",
        {
          on: { refresh: _vm.onRefresh },
          model: {
            value: _vm.refreshing,
            callback: function ($$v) {
              _vm.refreshing = $$v
            },
            expression: "refreshing",
          },
        },
        [
          _c(
            "van-list",
            {
              staticClass: "p-l-20 p-r-20 p-b-20",
              attrs: {
                "immediate-check": false,
                error: _vm.error,
                finished: _vm.finished,
                "finished-text": "没有更多了",
              },
              on: {
                "update:error": function ($event) {
                  _vm.error = $event
                },
                load: _vm.getList,
              },
              model: {
                value: _vm.loading,
                callback: function ($$v) {
                  _vm.loading = $$v
                },
                expression: "loading",
              },
            },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "bg-FF p-20 m-t-20",
                  on: {
                    click: function ($event) {
                      return _vm.change(item)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "flex col-center row-between" }, [
                    _c("img", {
                      staticClass: "w-52 h-52",
                      attrs: {
                        src: `${_vm.image_base_url}/${
                          _vm.icons.find(
                            (icon) => icon.groupId === item.groupId
                          )
                            ? _vm.icons.find(
                                (icon) => icon.groupId === item.groupId
                              ).icon
                            : "zhengxuanlist_icon.png"
                        }`,
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10",
                      },
                      [_vm._v(" " + _vm._s(item.title) + " ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "font-26 cor-B3 white-spc-nowrap" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.taskCreatedTime
                                ? _vm
                                    .moment(item.taskCreatedTime)
                                    .format("YYYY-MM-DD HH:mm")
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-20",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "6" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("部门"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "18" } }, [
                        _c("div", { staticClass: "cor-33 font-30" }, [
                          _vm._v(" " + _vm._s(item?.startUser?.deptName) + " "),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-20",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "6" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("流程状态"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "18" } }, [
                        _c("div", { staticClass: "cor-33 font-30" }, [
                          _vm._v(" " + _vm._s(item.businessStatusName) + " "),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  item.currentUserName
                    ? _c(
                        "van-row",
                        {
                          staticClass: "m-t-20",
                          attrs: { type: "flex", align: "center" },
                        },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "cor-88 font-30" }, [
                              _vm._v("当前处理人"),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c("div", { staticClass: "cor-33 font-30" }, [
                              _vm._v(" " + _vm._s(item.currentUserName) + " "),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  item.currentUserName
                    ? _c(
                        "van-row",
                        {
                          staticClass: "m-t-20",
                          attrs: { type: "flex", align: "center" },
                        },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("div", { staticClass: "cor-88 font-30" }, [
                              _vm._v("事由"),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c("div", { staticClass: "cor-33 font-30" }, [
                              _vm._v(" " + _vm._s(item.sy) + " "),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-20",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "6" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("摘要"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "18" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "cor-33 font-30",
                            staticStyle: {
                              "word-break": "break-all",
                              "white-space": "pre-line",
                            },
                          },
                          [_vm._v(" " + _vm._s(item.summary) + " ")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }